import { render } from "./Contact.vue?vue&type=template&id=fa870cac&scoped=true&ts=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=fa870cac&lang=scss&scoped=true"

import exportComponent from "D:\\nawarat-libya\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa870cac"]])

export default __exports__